import { render, staticRenderFns } from "./ModalTerms.vue?vue&type=template&id=6683ea5c&scoped=true&"
import script from "./ModalTerms.vue?vue&type=script&lang=js&"
export * from "./ModalTerms.vue?vue&type=script&lang=js&"
import style0 from "./ModalTerms.vue?vue&type=style&index=0&id=6683ea5c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6683ea5c",
  null
  
)

export default component.exports